export function classNames(classes: string[]) {
  return classes.join(" ");
}
